// Reports & Analytics Configuration — year-scoped module reports

export const reportsConfig = {
  entityName: 'Report',
  entityNamePlural: 'Reports',
  moduleName: 'Reports & Analytics',
  description:
    'Year-based analytics for Complaints, Risk Assessments, Deviations, Product Status Change, Todos, Ticketing, Manuals, and Contracts.',

  reportTypes: {
    complaint: {
      name: 'Complaints',
      icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
      description: 'Complaint volume, status, and trends by year',
      href: '/reports/complaint',
      category: 'quality',
    },
    risk: {
      name: 'Risk Assessments',
      icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z',
      description: 'Risk assessment status and volume by year',
      href: '/reports/risk-assessment',
      category: 'quality',
    },
    deviation: {
      name: 'Deviations',
      icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z',
      description: 'Deviation status, criticality, and volume by year',
      href: '/reports/deviation',
      category: 'quality',
    },
    productStatusChange: {
      name: 'Product Status Change',
      icon: 'M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4',
      description: 'Product status change records by year',
      href: '/reports/product-status-change',
      category: 'quality',
    },
    todo: {
      name: 'Todos',
      icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
      description: 'Todos created in the selected year',
      href: '/reports/todo',
      category: 'operations',
    },
    ticketing: {
      name: 'Ticketing',
      icon: 'M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z',
      description: 'Tickets by ticket date in the selected year',
      href: '/reports/ticketing',
      category: 'operations',
    },
    manuals: {
      name: 'Manuals',
      icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
      description: 'Manuals created in the selected year',
      href: '/reports/manuals',
      category: 'operations',
    },
    contracts: {
      name: 'Contracts',
      icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
      description: 'Contracts by start date in the selected year',
      href: '/reports/contracts',
      category: 'operations',
    },
  },
};
